module.exports = __webpack_public_path__ + "static/media/credit_card.0897bf7a.svg";